// extracted by mini-css-extract-plugin
export var graph = "styles-module--graph--2W3zC";
export var labelTitle = "styles-module--labelTitle--1L1vv";